import {h} from 'preact';
import {SubscribedComponent} from './Store/index';
import State from './Store/State';

/**
 * Component Properties.
 */
interface VisualTooltipProps
{
	[key: string]: void;
}

/**
 * Component State.
 */
interface VisualTooltipState
{
	/** Заголовок */
	title: string | JSX.Element | Array<string | JSX.Element>;
	/** Содержимое */
	content: string | JSX.Element | Array<string | JSX.Element>;
	/** Показывать? */
	visible: boolean;
	/** Положение курсора по X */
	cursorX: number;
	/** Положение курсора по Y */
	cursorY: number;
}

/**
 * Всплывающая подсказка.
 */
class VisualTooltip extends SubscribedComponent<State, VisualTooltipProps, VisualTooltipState>
{
	/**
	 * Всплывающая подсказка.
	 */
	public constructor( props: VisualTooltipProps )
	{
		super( props );
	}
	
	/**
	 * Rendered component mounted to the DOM.
	 */
	/*public componentDidMount(): void
	{
		super.componentDidMount();
	}*/
	
	/**
	 * Before component will be unmounted and destroyed.
	 */
	/*public componentWillUnmount(): void
	{
		super.componentWillUnmount();
	}*/
	
	/**
	 * Before render, return false to skip render.
	 */
	/*public shouldComponentUpdate( props: VisualTooltipProps, state: VisualTooltipState ): boolean
	{
		return true;
	}*/
	
	/**
	 * Render component.
	 */
	public render(
		_props: VisualTooltipProps,
		{title, content, visible, cursorX, cursorY}: VisualTooltipState,
	): JSX.Element
	{
		const style = {
			top: (cursorY + 30) + 'px',
			left: (cursorX + 15) + 'px',
		};
		const withContent = Boolean( title || content );
		const className = 'tooltip ' + (
			( visible && withContent )
			? ' visible'
			: ''
		);
		
		return (
			<aside class={className} style={style}>
				<h2>{title}</h2>
				<p>{content}</p>
			</aside>
		);
	}
	
	/**
	 * Handle Store changes.
	 */
	protected storeStateChanged(
		{visualData: {tooltip: {title, content, visible}}}: State,
	): void
	{
		if (
			( title === this.state.title )
			&& ( content === this.state.content )
			&& ( visible === this.state.visible )
		)
		{
			return;
		}
		
		if ( visible !== this.state.visible )
		{
			if ( visible )
			{
				document.addEventListener( 'mousemove', this.onMouseMove );
			}
			else
			{
				document.removeEventListener( 'mousemove', this.onMouseMove );
			}
		}
		
		this.setState( {title, content, visible} );
	}
	
	/**
	 * При перемещении мыши по документу.
	 */
	private onMouseMove = ( event: MouseEvent ): void =>
	{
		this.setState(
			{
				cursorX: event.clientX,
				cursorY: event.clientY,
			},
		);
	}
}

/**
 * Module.
 */
export {
	VisualTooltip as default,
	VisualTooltipProps,
	VisualTooltipState,
};



// WEBPACK FOOTER //
// ./app/Routes/Choose/App/VisualTooltip.tsx